import { useConnect } from '@zealforchange/redux-encapsulation'
import { State } from '@reducers/modules/formInit'
import * as actions from '@actions/formInit'

export function useFormDispatch() {
  return useConnect<{ FormOptionsInit: State }, { FormOptionsInit: State }, typeof actions>((state: { FormOptionsInit: State }) => {
    return { FormOptionsInit: state.FormOptionsInit }
  }, actions) as [{ FormOptionsInit: State }, typeof actions]
}
